import { render, staticRenderFns } from "./listService.vue?vue&type=template&id=70b8f8f1&scoped=true"
import script from "./listService.vue?vue&type=script&lang=js"
export * from "./listService.vue?vue&type=script&lang=js"
import style0 from "./listService.vue?vue&type=style&index=0&id=70b8f8f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8f8f1",
  null
  
)

export default component.exports